import React, { useState } from "react";
import "./ScreenshotGallery.css";

const ScreenshotGallery = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const screenshots = [
    {
      src: "/01-home.PNG",
      title: "Page d'accueil",
      description: "Interface principale avec navigation intuitive",
    },
    {
      src: "/02-listings.PNG",
      title: "Catalogue des annonces",
      description: "Parcourez tous les produits avicoles disponibles",
    },
    {
      src: "/03-0-listing_detail.PNG",
      title: "Détail d'une annonce",
      description: "Informations complètes sur chaque produit",
    },
    {
      src: "/04-my_purchases.PNG",
      title: "Mes achats",
      description: "Historique et suivi de vos commandes",
    },
    {
      src: "/05-chats.PNG",
      title: "Messagerie",
      description: "Chat en temps réel avec les vendeurs",
    },
    {
      src: "/06-profile.PNG",
      title: "Profil utilisateur",
      description: "Gérez vos informations personnelles",
    },
    {
      src: "/07-seller-dashboard.PNG",
      title: "Tableau de bord vendeur",
      description: "Statistiques et gestion des ventes",
    },
    {
      src: "/08-my_listings.PNG",
      title: "Mes annonces",
      description: "Gérez vos publications et annonces",
    },
    {
      src: "/09-new_listing.PNG",
      title: "Nouvelle annonce",
      description: "Publiez facilement vos produits",
    },
    {
      src: "/10-order_form.PNG",
      title: "Formulaire de commande",
      description: "Processus de commande simplifié",
    },
    {
      src: "/11-reviews.PNG",
      title: "Avis et évaluations",
      description: "Système de notation et de commentaires",
    },
  ];

  return (
    <section id="galerie" className="section">
      <div className="container">
        <div className="gallery__header text-center mb-5">
          <h2 className="gallery__title animate-fade-in-up">
            Découvrez l'Application
          </h2>
          <p className="gallery__subtitle animate-fade-in-up">
            Explorez les différentes fonctionnalités de Chiesugu à travers ces
            captures d'écran de l'application mobile.
          </p>
        </div>

        <div className="gallery__container">
          {/* Miniatures */}
          <div className="gallery__thumbnails">
            {screenshots.map((screenshot, index) => (
              <div
                key={index}
                className={`gallery__thumbnail ${
                  selectedImage === index ? "gallery__thumbnail--active" : ""
                }`}
                onClick={() => setSelectedImage(index)}
              >
                <img
                  src={screenshot.src}
                  alt={screenshot.title}
                  className="gallery__thumbnail-img"
                />
                <div className="gallery__thumbnail-overlay">
                  <span className="gallery__thumbnail-title">
                    {screenshot.title}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {/* Image principale */}
          <div className="gallery__main">
            <div className="gallery__main-image animate-fade-in">
              <img
                src={screenshots[selectedImage].src}
                alt={screenshots[selectedImage].title}
                className="gallery__main-img"
              />
              <div className="gallery__main-info">
                <h3 className="gallery__main-title">
                  {screenshots[selectedImage].title}
                </h3>
                <p className="gallery__main-description">
                  {screenshots[selectedImage].description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScreenshotGallery;
